import { primaryAppPath } from "./appNavigation";

export const CHAT_ACCOUNT_RETURN_PATH = "/chat";
export const WORKSPACE_ACCOUNT_RETURN_PATH = "/chat-workspace";

const ALLOWED_ACCOUNT_RETURN_PATHS = new Set([
  CHAT_ACCOUNT_RETURN_PATH,
  WORKSPACE_ACCOUNT_RETURN_PATH,
]);

const allowedAccountReturnPath = (candidate) => {
  if (typeof candidate !== "string") return null;
  return ALLOWED_ACCOUNT_RETURN_PATHS.has(candidate) ? candidate : null;
};

export const accountPageHref = (
  returnTo = primaryAppPath(),
) => {
  const safeReturnTo =
    allowedAccountReturnPath(returnTo) || primaryAppPath();
  return `/account?return_to=${encodeURIComponent(safeReturnTo)}`;
};

export const accountReturnPath = ({ search = "", state = null } = {}) => {
  const stateReturnTo = allowedAccountReturnPath(state?.returnTo);
  if (stateReturnTo) return stateReturnTo;

  const queryReturnTo = allowedAccountReturnPath(
    new URLSearchParams(search).get("return_to"),
  );
  return queryReturnTo || primaryAppPath();
};
